module.exports = __webpack_public_path__ + "img/Frame_7.2c97cb2c.png";